import { combineEpics } from 'redux-observable';
import { fetchConfigEpic } from './slices/config.slice';
import { BehaviorSubject, mergeMap } from 'rxjs';

export const epic$ = new BehaviorSubject(combineEpics(fetchConfigEpic));
export const rootEpic = (action$: any, state$: any, pluging: any) => epic$.pipe(mergeMap((epic) => epic(action$, state$, pluging)));
